import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';
import { ComboField } from '../../utils';
import { get } from 'lodash';

export class IconsLocationSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'icons.location');
    }

    // a kinesis theme saved before the indicator was a setting of its own draws a bar, so the editor
    // shows that rather than the default it would otherwise merge in. see MapMarkersService.colorIndicator
    async mapEntityToEditor(entity: ThemeResponse): Promise<any> {
        const values = await super.mapEntityToEditor(entity);
        if (!get(entity.settings, 'icons.location.indicator.style') && values.set === 'kinesis') {
            values.indicator.style = 'left-bar';
        }
        return values;
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            ComboField('set', this.translateField('icon.set'), true, [
                { key: 'default', value: 'Default' },
                { key: 'kinesis', value: 'Kinesis' },
            ]),
            ComboField('indicator.style', this.translateField('icon.indicator'), true, [
                { key: 'none', value: 'None' },
                { key: 'left-bar', value: 'Left Bar' },
                { key: 'left-pill', value: 'Left Pill' },
                { key: 'bottom-pill', value: 'Bottom Pill' },
            ]),
        ];
    }

}
